module.exports = __webpack_public_path__ + "img/key.c00f12df.svg";